import {PrimaryLink, SecondaryLink} from "components/Links";
import React from "react";
import styled from "styled-components";
import {GAME_ZONE_URL, GZ_SITE_PATH} from "modules/constants";
import {useStore} from "modules/hooks";

const Buttons = styled.div`
	display: flex;
	justify-content: center;
	gap: 20px;
	width: 100%;

	& > * {
		min-width: 270px;
	}

	@media (max-width: 840px) {
		& > * {
			width: 100%;
			min-width: 0;
		}
	}
`;

const getUri = (page: string) => `${GAME_ZONE_URL}${page}?redirectUri=${GZ_SITE_PATH}/`;

export const AuthButtons: React.FC = () => {
	const {I18n} = useStore();

	return (
		<Buttons>
			<PrimaryLink href={getUri("login")}>{I18n.t("gz_cta.login")}</PrimaryLink>

			<SecondaryLink href={getUri("registration")}>
				{I18n.t("gz_cta.registration")}
			</SecondaryLink>
		</Buttons>
	);
};
